module.exports = "<md-progress-circular class=md-hue-2 md-mode=indeterminate md-diameter=60px></md-progress-circular> <div class=space-m-v-s>DT Studio loading...</div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/splash-screen/splash-screen.html
// module id = dZ/z
// module chunks = 1